// extracted by mini-css-extract-plugin
export var article = "styles-module--article--1Ehul";
export var content = "styles-module--content--2PG8B";